import { render, staticRenderFns } from "./forgotPwd.vue?vue&type=template&id=1dd1ada2&scoped=true&"
import script from "./forgotPwd.vue?vue&type=script&lang=js&"
export * from "./forgotPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd1ada2",
  null
  
)

export default component.exports